import { secureGet, securePost, securePut } from "../../Config/ApiConfig";

export const getPayments = async ({ page, size, filters, sorter, sort_by, sort_direction, search_string }) => {
    let url = '/payments?page=' + page + '&page_size=' + size;

    // Add filters to the URL if they exist
    if (filters && Object.keys(filters).length > 0) {
        url += '&filters=' + encodeURIComponent(JSON.stringify(filters));
    }
    // Global search string (supported by backend)
    if (typeof search_string === 'string' && search_string.trim() !== '') {
        url += '&search_string=' + encodeURIComponent(search_string);
    }
    if (sort_by) {
        url += '&sort_by=' + encodeURIComponent(String(sort_by));
        if (sort_direction) {
            url += '&sort_direction=' + encodeURIComponent(String(sort_direction));
        }
    } else if (sorter?.field) {
        url += '&sort_by=' + encodeURIComponent(String(sorter.field));
        url += '&sort_direction=' + (sorter.order === 'ascend' ? 'asc' : 'desc');
    }

    const { data } = await secureGet(url);
    return data;
};

export const getProducts = async () => {
    const { data } = await secureGet('/payments/products')
    return data;
};

export const validatePromoCode = async (body) => {
    const { data } = await securePost('/payments/validate-promotion-code', body)
    return data;
};

export const getAutoChargeSettings = async () => {
    const { data } = await secureGet('/payments/settings')
    return data;
};

export const createCheckoutSession = async (body) => {
    const { data } = await securePost('/payments/checkout-session', body)
    return data;
};

export const getBillingDetails = async (params) => {
    const { data } = params
        ? await secureGet('/payments/customer-portal', { params })
        : await secureGet('/payments/customer-portal')
    return data;
};

export const getDefaultPaymentMethod = async () => {
    const { data } = await secureGet('/payments/default-payment-method')
    return data;
};

export const getPaymentDocumentUrls = async (paymentId) => {
    const { data } = await secureGet(`/payments/${paymentId}/document-urls`)
    return data;
};

export const getPaymentCheckoutUrl = async (paymentId) => {
    const { data } = await secureGet(`/payments/${paymentId}/checkout-url`)
    return data;
};

export const updateAutoChargeSettings = async (body) => {
    const { data } = await securePut('/payments/settings', body)
    return data;
};
